export interface UpdateLendUserRemindRequestCollection {
  id: number // 資料ID
  revision: number
}

export function UpdateLendUserRemindRequestCollectionToJSON(
  value: UpdateLendUserRemindRequestCollection
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
